var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconScmpLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 31,
  viewBox: "0 0 40 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 31V0H40V31H0ZM3.45071 27.5294H18.2664V3.46707H3.45071V27.5294ZM21.7336 27.5294H36.5493V3.46707H21.7336V27.5294Z",
  fill: "white"
})));
export default SvgIconScmpLogo;